import { render, staticRenderFns } from "./LmLeaders.vue?vue&type=template&id=b53e9312"
import script from "./LmLeaders.vue?vue&type=script&lang=js"
export * from "./LmLeaders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports